import { chakra, ChakraProps } from '@chakra-ui/react'

import { chakraColorToCSSVariable } from 'src/lib/utils'
import { BrandColor } from 'src/types'

import InsideCustomIcon from '../InsideCustomIcon'

const NotionIcon = ({
  brandColor = 'brand.200',
  ...props
}: {
  brandColor?: BrandColor
} & ChakraProps) => {
  return (
    <InsideCustomIcon brandColor={brandColor}>
      <chakra.svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M3.44888 3.65891C4.09695 4.18586 4.3402 4.14586 5.55816 4.06412L17.0385 3.37456C17.2817 3.37456 17.0793 3.13108 16.9985 3.09108L15.0908 1.71109C14.7259 1.42761 14.2386 1.10239 13.3055 1.18326L2.19008 1.99543C1.78525 2.03543 1.70359 2.23891 1.86517 2.40065L3.44888 3.65891ZM4.13778 6.33716V18.4276C4.13778 19.0771 4.46182 19.3206 5.19243 19.2797L17.8091 18.5493C18.5397 18.5093 18.6213 18.0624 18.6213 17.5345V5.52499C18.6213 4.99803 18.4189 4.71369 17.9715 4.75369L4.78673 5.52499C4.30023 5.56586 4.13778 5.80934 4.13778 6.33629V6.33716ZM16.5928 6.98499C16.6736 7.3502 16.5928 7.71542 16.228 7.75716L15.6198 7.8789V16.8041C15.0917 17.0884 14.6052 17.2511 14.1995 17.2511C13.5496 17.2511 13.3872 17.0476 12.9007 16.4398L8.92451 10.1911V16.2363L10.1824 16.5215C10.1824 16.5215 10.1824 17.2519 9.16775 17.2519L6.36869 17.4137C6.2879 17.2519 6.36869 16.8458 6.65277 16.765L7.3825 16.5624V8.56846L6.37043 8.48672C6.28877 8.12151 6.49205 7.59455 7.05933 7.55368L10.0617 7.35107L14.2003 13.6806V8.08064L13.1448 7.95977C13.064 7.51281 13.3881 7.18846 13.7938 7.14846L16.5928 6.98499ZM1.25706 0.899782L12.8199 0.0476103C14.2394 -0.0741286 14.6052 0.0067408 15.4973 0.656305L19.1886 3.25282C19.7967 3.69891 20 3.82065 20 4.3076V18.5493C20 19.4415 19.676 19.9702 18.5405 20.0502L5.11163 20.8624C4.26027 20.9032 3.85371 20.7815 3.40718 20.2128L0.688906 16.6824C0.202415 16.0328 0 15.5467 0 14.978V2.31891C0 1.58935 0.324907 0.979782 1.25706 0.899782Z"
          fill={chakraColorToCSSVariable(brandColor)}
        />
      </chakra.svg>
    </InsideCustomIcon>
  )
}

export default NotionIcon
